export const ERROR_MISSING_CIEC = 'ERROR_MISSING_CIEC';
export const ERROR_RFC_NOT_SAME_MESSAGE = 'Rfc del deudor no es el mismo que la factura';
export const ERROR_RFC_NOT_SAME_TYPE = 'RFC Error';

export const ERROR_NO_NODES_TO_LOAD = 'No hay nodos para cargar';
